var React = require('react');

function CancelInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50 0C22.35 0 0 22.35 0 50s22.35 50 50 50 50-22.35 50-50S77.65 0 50 0zm25 67.95L67.95 75 50 57.05 32.05 75 25 67.95 42.95 50 25 32.05 32.05 25 50 42.95 67.95 25 75 32.05 57.05 50 75 67.95z"}));
}

CancelInline.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = CancelInline;

CancelInline.default = CancelInline;
